
import { Button } from "@/components/ui/button";
import { Download, Filter, FileSpreadsheet, FileText } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface CRMActionsProps {
  onToggleFilter: () => void;
  onDownload: () => void;
  onExportExcel: () => void;
  showFilters: boolean;
}

export const CRMActions = ({ onToggleFilter, onDownload, onExportExcel, showFilters }: CRMActionsProps) => {
  return (
    <div className="flex gap-2">
      <Button onClick={onToggleFilter} variant="outline" className="flex items-center gap-2">
        <Filter size={16} />
        Filtres {showFilters ? '▲' : '▼'}
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="flex items-center gap-2">
            <Download size={16} />
            Exporter
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-white">
          <DropdownMenuItem onClick={onDownload} className="flex items-center gap-2">
            <FileSpreadsheet size={16} />
            <span>CSV</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onExportExcel} className="flex items-center gap-2">
            <FileText size={16} />
            <span>Excel</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
